// @flow
import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import type { PostItem } from 'store/modules/listing';
import throttle from 'lodash/throttle';
import { getScrollBottom } from 'lib/common';
import { SearchActions } from 'store/actionCreators';
import SearchResultItem from '../SearchResultItem';
import SearchHistory from '../SearchHistory';
import type {State} from '../../../store';
import './SearchResults.scss';

type Props = {
  result: ?{
    count: number,
    data: PostItem[],
  },
  onSearchNext: () => any,
  menu: string,
  currentKeyword: string,
};

class SearchResults extends Component<Props> {
  onScroll = throttle(() => {
    const scrollBottom = getScrollBottom();
    if (scrollBottom > 1000) return;
    const { result, onSearchNext } = this.props;
    if (result && result.estimatedTotalHits > result.hits.length) onSearchNext();
  }, 250);

  renderList() {
    const { result, menu } = this.props;
    if (!result) return null;
    return result.hits.map(post => (
      <SearchResultItem
        key={post.id}
        post={post}
        menu={menu}
      />
    ));
  }

  componentDidMount() {
    this.listenScroll();
  }

  listenScroll = () => {
    window.addEventListener('scroll', this.onScroll);
  };

  unlistenScroll = () => {
    window.removeEventListener('scroll', this.onScroll);
  };

  componentWillUnmount() {
    this.unlistenScroll();
  }

  render() {
    const { result, onSearchNext, menu, currentKeyword, loading } = this.props;
    const menuText = menu === 'products' ? '상품' : '포스트';
    const q = currentKeyword
      .replace(/%26/g,"&")
      .replace(/%2B/g,"+");
    return (
      <div className="SearchResults">
        {!loading ?
          <Fragment>
            <div className="count">
              {result ?
                <div className="not_found">
                  <p>
                    총 <b>{result.estimatedTotalHits}개</b>의 {menuText}을 찾았습니다.
                  </p>
                </div> :
                <div>
                  {
                    currentKeyword ?
                      <div className="not_found">
                        <p>
                          <b>{`'${q}'`}</b>와(과) 일치하는 검색결과가 없습니다.
                        </p>
                      </div> :
                      <SearchHistory />
                  }
                </div>
              }
            </div>
            {this.renderList()}
          </Fragment> :
          <div>Loading...</div>
        }
      </div>
    );
  }
}

const mapStateToProps = ({ pender }: State) => ({
  loading: pender.pending['search/PUBLIC_SEARCH'],
});

export default connect(
  mapStateToProps,
  () => ({}),
)(SearchResults);



// WEBPACK FOOTER //
// ./src/components/search/SearchResults/SearchResults.js